import React from 'react'
import { SomethingWentWrong } from '@components/Errors/SomethingWentWrong'
import { Box } from '@ui'

export const EditorFallback = (props: { error: Error }) => (
    <Box
        horizontal
        gap="sm"
        rounded="sm"
        background="level3"
        height="x6"
        padding="lg"
        alignItems="center"
        color="gray2"
    >
        <SomethingWentWrong error={props.error} />
    </Box>
)
